// eslint-disable-next-line no-unused-vars
import { TimesheetOperationType } from '@/shared/constants/timesheet/TimesheetOperationType'

export default class TimesheetPayload {
  constructor({
    bookingId,
    candidateId,
    locationId,
    operationType,
    startTimeLocal,
    endTimeLocal,
    payOptionType,
    breakMinutes,
  } = {}) {
    /**
     * @type {Number}
     */
    this.bookingId = bookingId

    /**
     * @type {Number}
     */
    this.candidateId = candidateId

    /**
     * @type {Number}
     */
    this.locationId = locationId

    /**
     * @type {TimesheetOperationType}
     */
    this.operationType = operationType

    /**
     * @type {String}
     */
    this.startTimeLocal = startTimeLocal

    /**
     * @type {String}
     */
    this.endTimeLocal = endTimeLocal

    /**
     * @type {String}
     */
    this.payOptionType = payOptionType

    /**
     * @type {Number}
     */
    this.breakMinutes = breakMinutes
  }
}
